(function() {
    'use strict';

    angular.module('news')
        .controller('NewsUpdateController', NewsUpdateController);

    NewsUpdateController.$inject = ['$state', 'notificationSrvc', 'newsDataSrvc', 'newsMessagesConst', 'errorNotificationSrvc'];

    function NewsUpdateController($state, notificationSrvc, newsDataSrvc, newsMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            title_pl: [],
            title_en: [],
            title_de: [],
            title_cpde: [],
            title_cpen: [],
            content_pl: [],
            content_de: [],
            content_en: [],
            content_cpen: [],
            content_cpde: [],
            publication_date: [],
            nonFieldErrors: []
        };
        self.newsData = {
            title_pl: '',
            title_en: '',
            title_de: '',
            title_cpde: '',
            title_cpen: '',
            content_pl: '',
            content_de: '',
            content_en: '',
            content_cpen: '',
            content_cpde: '',
            publication_date: ''
        };

        self.updateNews = updateNews;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getNews();
        }

        function getNews() {
            return newsDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.newsData = response;

                delete self.newsData.date_modified;
                delete self.newsData.date_added;
                return response;
            });
        }

        function updateNews() {
            newsDataSrvc.update({
                pk: self.newsData.pk
            }, self.newsData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", newsMessagesConst.update);
                    $state.go('layout.news.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

    }
})();
